module.exports = __webpack_public_path__ + "img/platformAnnouncementCn.a0ed6fe9.png";